exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".added-product-overview-wrap[data-v-7721e199]{padding:20px}", ""]);

// exports
